var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.9997 7.5V10.8333M9.9997 14.1667H10.008M18.108 15L11.4414 3.33332C11.296 3.07682 11.0852 2.86347 10.8305 2.71504C10.5757 2.56661 10.2862 2.4884 9.99136 2.4884C9.69654 2.4884 9.40699 2.56661 9.15226 2.71504C8.89753 2.86347 8.68673 3.07682 8.54136 3.33332L1.8747 15C1.72777 15.2545 1.65072 15.5432 1.65137 15.8371C1.65202 16.1309 1.73035 16.4194 1.8784 16.6732C2.02646 16.927 2.23899 17.1371 2.49444 17.2823C2.7499 17.4275 3.0392 17.5026 3.33303 17.5H16.6664C16.9588 17.4997 17.246 17.4225 17.4991 17.2761C17.7522 17.1297 17.9624 16.9192 18.1085 16.6659C18.2545 16.4126 18.3314 16.1253 18.3313 15.8329C18.3312 15.5405 18.2542 15.2532 18.108 15Z",
    stroke: "#F10000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorTriangle);
export default __webpack_public_path__ + "static/media/error-triangle.b3bf3ea29b225cacac03d5c6fc4d743c.svg";
export { ForwardRef as ReactComponent };